export const aggregationOperations = [
    {
        code: "SUM",
        id: "sum",
        format: "sum({})"
    },
    {
        code: "COUNT",
        id: "count",
        format: "count({})"
    },
    {
        code: "COUNT_DISTINCT",
        id: "count distinct",
        format: "count(distinct {})"
    },
    {
        code: "MIN",
        id: "min",
        format: "min({})"
    },
    {
        code: "MAX",
        id: "max",
        format: "max({})"
    },
    {
        code: "AVG",
        id: "avg",
        format: "avg({})"
    }
]
